<template>
	<div class="box">
		<div>
			<div class="numDoctor">
				<div class="text1">
					<p>医护人员注册用户</p>
					<p>{{ysNum+zlNum}}</p>
				</div>
				<div class="text2">
					<p>昨日新增</p>
					<p>{{jrxzzc}}</p>
					<!--<p>1</p>-->
				</div>
				<div class="text2">
					<p>七日新增</p>
					<p>{{qrxzzc}}</p>
				</div>
			</div>
			<div class="chartsDoc">
				<div class="chartsDocheader">
					<div>
						<el-date-picker
						    v-model="value1"
						    type="daterange"
						    range-separator="至"
						    start-placeholder="开始月份"
						    end-placeholder="结束月份"
						    value-format="yyyy-MM-dd"
						    @blur="dateFn()">
						    </el-date-picker>
					</div>
					<div class="datebtn">
						<div :class="btnStr==7?'active':''" @click="dayFn(7)">近7日</div>
						<div :class="btnStr==30?'active':''" @click="dayFn(30)">近30日</div>
					</div>
				</div>
				<div class="chartsDoccontent">
					<div>
						<charts :type="1" :options="options1" :dates="value1" :datazc="zcxz" :datazs="zczs"></charts>
					</div>
					<div>
						<charts :type="2" :options="options1" :dates="value1" :datazc="zcxz" :datazs="zczs"></charts>
					</div>
				</div>
			</div>
		</div>
		<div>
			<div class="numDoctor">
				<div class="text1">
					<p>总认证人数</p>
					<p>{{gjNum+cjNum+gj1Num+cj1Num}}</p>
				</div>
				<div class="text2 fl"   style="margin-right: 65px;">
					<p>昨日新增</p>
					<p>{{jrxzrz}}</p>
					<!--<p>1</p>-->
				</div>
				<div class="text2">
					<p>七日新增</p>
					<p>{{qrxzrz}}</p>
					<!--<p>8</p>-->
				</div>
				<div class="text1 fl"   style="margin-right: 65px;">
					<p>医生认证</p>
					<p>{{gjNum+cjNum}}</p>
				</div>
				<div class="text1">
					<p>助理认证</p>
					<p>{{gj1Num+cj1Num}}</p>
				</div>
				<div class="text1 fl"  style="margin-right: 65px;">
					<p>医生高级</p>
					<p>{{gjNum}}</p>
				</div>
				<div class="text1">
					<p>医生初级</p>
					<p>{{cjNum}}</p>
				</div>
			</div>
			<div class="chartsDoc">
				<div class="chartsDocheader">
					<div>
						<el-date-picker
						    v-model="value2"
						    type="daterange"
						    range-separator="至"
						    start-placeholder="开始月份"
						    end-placeholder="结束月份"
						    value-format="yyyy-MM-dd"
						    @blur="date1Fn()">
						    </el-date-picker>
					</div>
					<div class="datebtn">
						<div :class="btn1Str==7?'active':''" @click="day1Fn(7)">近7日</div>
						<div :class="btn1Str==30?'active':''" @click="day1Fn(30)">近30日</div>
					</div>
				</div>
				<div class="chartsDoccontent">
					<div>
						<charts :type="1" :options="options2" :dates="value2" :datazc="rzxz" :datazs="rzzs" :datafb="rzfb" :datafb1="ysfb"></charts>
					</div>
					<div>
						<charts :type="2" :options="options2" :dates="value2" :datazc="rzxz" :datazs="rzzs" :datafb="rzfb" :datafb1="ysfb"></charts>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {user_count,yhrx_zcxz,yhrx_zczs,yhrx_rzzs,yhrx__rzxz} from '../components/http/api.js'
	import charts from '../component/charts.vue'
	export default{
		components:{
			charts
		},
		data(){
			return{
				value1:[],
				value2:[],
				btnStr:7,
				btn1Str:7,
				options1:[{
					id:1,
					name:'医护人员注册总数',
				},{
					id:2,
					name:'医护人员注册新增',
				}],
				options2:[{
					id:1,
					name:'医护人员认证总数',
				},{
					id:2,
					name:'医护人员认证新增',
				},{
					id:3,
					name:'医生/助理认证分布',
				},{
					id:4,
					name:'高级/初级认证分布',
				}],
				hzNum:0,
				ysNum:0,
				cjNum:0,
				cj1Num:0,
				gjNum:0,
				zlNum:0,
				gj1Num:0,
				zl1Num:0,
				jrxzzc:0,
				qrxzzc:0,
				jrxzrz:0,
				qrxzrz:0,
				rzfb:  {
					tooltip: {
				        trigger: 'item',
				        formatter: '{a} <br/>{b}: {c} ({d}%)'
				    },
				    legend: {
				        orient: 'vertical',
				        left: 10,
				        top:20,
				        data: ['助理认证', '医生认证']
				    },
		            series: [ {
			            name: '认证',
			            type: 'pie',
			            radius: ['50%', '70%'],
			            avoidLabelOverlap: false,
			            label: {
			                show: false,
			                position: 'center'
			            },
			            emphasis: {
			                label: {
			                    show: true,
			                    fontSize: '30',
			                    fontWeight: 'bold'
			                }
			            },
			            labelLine: {
			                show: false
			            },
			            data: [
			                
			            ]
			        }],
		        },
		        ysfb:  {
		        	tooltip: {
				        trigger: 'item',
				        formatter: '{a} <br/>{b}: {c} ({d}%)'
				    },
				    legend: {
				        orient: 'vertical',
				        left: 10,
				        top:20,
				        data: ['初级认证', '高级认证']
				    },
		            series: [ {
			            name: '认证',
			            type: 'pie',
			            radius: ['50%', '70%'],
			            avoidLabelOverlap: false,
			            label: {
			                show: false,
			                position: 'center'
			            },
			            emphasis: {
			                label: {
			                    show: true,
			                    fontSize: '30',
			                    fontWeight: 'bold'
			                }
			            },
			            labelLine: {
			                show: false
			            },
			            data: [
			             	
			            ]
			        }],
		        },
				zcxz:{
		            title: {
//		                text: 'Biu~简单柱状图示例'
		            },
		            tooltip: {},
		            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
			            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
			        },
		            legend: {
		            	top:20
//		                data:['人数']
		            },
		            xAxis: {
		            	type: 'category',
		                data: [0,0,0,0]
		            },
		            yAxis: {
		            	type: 'value'
		            },
		            series: [{
		                name: '人数',
		                type: 'bar',
		                data: [0,0,0,0]
		            }],
		            color: ['rgba(29,181,255,1)']
		        },
				zczs:{
		            title: {
//		                text: 'Biu~简单柱状图示例'
		            },
		            tooltip: {},
		            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
			            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
			        },
		            legend: {
		            	top:20
//		                data:['人数']
		            },
		            xAxis: {
		            	type: 'category',
		               	data: [0,0,0,0]
		            },
		            yAxis: {
		            	type: 'value'
		            },
		            series: [{
		                name: '人数',
		                type: 'line',
		                data: [0,0,0,0]
		            }],
		            color: ['rgba(29,181,255,1)','#aaaaaa']
		        },
		        rzxz:{
		            title: {
//		                text: 'Biu~简单柱状图示例'
		            },
		            tooltip: {},
		            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
			            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
			        },
		            legend: {
		            	top:20
//		                data:['人数']
		            },
		            xAxis: {
		            	type: 'category',
		                data: [0,0,0,0]
		            },
		            yAxis: {
		            	type: 'value'
		            },
		            series: [{
		                name: '人数',
		                type: 'bar',
		                data: [0,0,0,0]
		            }],
		            color: ['rgba(29,181,255,1)']
		        },
				rzzs:{
		            title: {
//		                text: 'Biu~简单柱状图示例'
		            },
		            tooltip: {},
		            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
			            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
			        },
		            legend: {
		            	top:20
//		                data:['人数']
		            },
		            xAxis: {
		            	type: 'category',
		               	data: [0,0,0,0]
		            },
		            yAxis: {
		            	type: 'value'
		            },
		            series: [{
		                name: '人数',
		                type: 'line',
		                data: [0,0,0,0]
		            }],
		            color: ['rgba(29,181,255,1)','#aaaaaa']
		        }
			}
			
		},
		mounted() {
			this.value1=[this.getDay(-7),this.getDay(-1)];
			this.value2=[this.getDay(-7),this.getDay(-1)];
			this.user_countFn();
			this.yhrx_zcxzFn();
			this.yhrx_zczsFn();
			this.yhrx__rzxzFn();
			this.yhrx_rzzsFn();
			this.qzcxzFn()
		},
		methods:{
			dayFn(i){
				this.btnStr=i;
				this.value1=[this.getDay(-i),this.getDay(-1)];
				this.yhrx_zcxzFn();
				this.yhrx_zczsFn();
			},
			day1Fn(i){
				this.btn1Str=i;
				this.value2=[this.getDay(-i),this.getDay(-1)];
				this.yhrx__rzxzFn();
				this.yhrx_rzzsFn();
			},
			getDay(day){
			    var today = new Date();
			    var targetday_milliseconds=today.getTime() + 1000*60*60*24*day;
			    today.setTime(targetday_milliseconds); //注意，这行是关键代码
			    var tYear = today.getFullYear();
			    var tMonth = today.getMonth();
			    var tDate = today.getDate();
			    tMonth = this.doHandleMonth(tMonth + 1);
			    tDate = this.doHandleMonth(tDate);
			    return tYear+"-"+tMonth+"-"+tDate;
			},
			doHandleMonth(month){
			    var m = month;
			    if(month.toString().length == 1){
			     m = "0" + month;
			    }
			    return m;
			},
			user_countFn(){
				user_count().then(res=>{
					for(var i=0;i<res.list.length;i++){
						if(res.list[i].id==8){ 
							this.hzNum=res.list[i].regsum;
							var arr=[{
								value:this.gjNum+this.cjNum,
//								value:566,
								name: '医生认证'
							},{
								value:this.gj1Num+this.cj1Num,
//								value:24,
								name: '助理认证'
							}]
							var arr1=[{
								value:this.gj1Num+this.gjNum,
//								value:552,
								name: '高级认证'
							},{
								value:this.cj1Num+this.cjNum,
//								value:38,
								name: '初级认证'
							}]
							this.rzfb.series[0].data=arr;
							this.ysfb.series[0].data=arr1;
						}
						if(res.list[i].id==2) this.ysNum=res.list[i].regsum;
						if(res.list[i].id==3) this.zlNum=res.list[i].regsum;
						if(res.list[i].id==3) this.gj1Num=res.list[i].gjtj;
						if(res.list[i].id==3) this.cj1Num=res.list[i].pttj;
						if(res.list[i].id==2){
							this.gjNum=res.list[i].gjtj;
						}
						if(res.list[i].id==2){
							this.cjNum=res.list[i].pttj;
						}
					}
				})
			},
			dateFn(){
				this.yhrx_zcxzFn();
				this.yhrx_zczsFn();
			},
			yhrx_zcxzFn(){
				var data={
					start_time:this.value1[0],
					end_time:this.value1[1]
				}
				yhrx_zcxz(data).then(res=>{
					var arr1=res.ay_time;
					var arr2=res.ay_data;
//					var arr1s=["06-22", "06-23", "06-24", "06-25", "06-26", "06-27", "06-28"];
//					var arr2s=[1,0,1,2,0,2,1];
					this.zcxz.xAxis.data=arr1;
					this.zcxz.series[0].data=arr2;
				})
			},
			yhrx_zczsFn(){
				var data={
					start_time:this.value1[0],
					end_time:this.value1[1]
				}
				yhrx_zczs(data).then(res=>{
					var arr1=res.ay_time;
					var arr2=res.ay_data;
//					var arr2s=[684,685,686,687,688,689,690];
//					console.log(arr2s)
					this.zczs.xAxis.data=arr1;
					this.zczs.series[0].data=arr2;
				})
			},
			date1Fn(){
				this.yhrx__rzxzFn();
				this.yhrx_rzzsFn();
			},
			yhrx__rzxzFn(){
				var data={
					start_time:this.value2[0],
					end_time:this.value2[1]
				}
				yhrx__rzxz(data).then(res=>{
					var arr1=res.ay_time;
					var arr2=res.ay_data;
//					var arr1s=["06-22", "06-23", "06-24", "06-25", "06-26", "06-27", "06-28"];
//					var arr2s=[2,0,1,2,0,2,1];
//					var arr2s=[1,1,2,1,1,1,1];
					this.rzxz.xAxis.data=arr1;
					this.rzxz.series[0].data=arr2;
				})
			},
			yhrx_rzzsFn(){
				var data={
					start_time:this.value2[0],
					end_time:this.value2[1]
				}
				yhrx_rzzs(data).then(res=>{
					var arr1=res.ay_time;
					var arr2=res.ay_data;
//					var arr2s=[583,584,585,587,588,589,590];
					this.rzzs.xAxis.data=arr1;
					this.rzzs.series[0].data=arr2;
				})
			},
			qzcxzFn(){
				var data={
					start_time:this.getDay(-7),
					end_time:this.getDay(-1)
				}
				var data1={
					start_time:this.getDay(-1),
					end_time:this.getDay(0)
				}
				yhrx_zcxz(data).then(res=>{
					var arr=res.ay_data;
					for(var i=0;i<arr.length;i++){
						this.qrxzzc+=Number(arr[i])
					}
				})
				yhrx_zcxz(data1).then(res=>{
					var arr=res.ay_data;
					for(var i=0;i<arr.length;i++){
						this.jrxzzc+=Number(arr[i])
					}
				})
				yhrx__rzxz(data).then(res=>{
					var arr=res.ay_data;
					for(var i=0;i<arr.length;i++){
						this.qrxzrz+=Number(arr[i])
					}
				})
				yhrx__rzxz(data1).then(res=>{
					var arr=res.ay_data;
					for(var i=0;i<arr.length;i++){
						this.jrxzrz+=Number(arr[i])
					}
				})
			},
		}
	}
</script>

<style scoped>
	.box{
		width: 100%;
		height: 100%;
	}
	.box>div{
		height: 364px;
		width: 100%;
		display: flex;
		justify-content: space-between;
		/*background: #FFFFFF;*/
	}
	
	.box>div:nth-child(1){
		margin-bottom: 7px;
	}
	.numDoctor{
		width: 212px;
		height: 344px;
		padding:10px 20px;
		border-radius:3px;
		/*border-right: 3px solid rgba(198,198,198,1);*/
		background: #FFFFFF;
	}
	.text1,.text2{
		margin-bottom: 30px;
	}
	.text1>p:nth-child(1){
		font-size:15px;
		font-weight:400;
		color:rgba(74,74,74,1);
		line-height:23px;
	}
	.text1>p:nth-child(2){
		font-size:30px;
		font-weight:600;
		color:rgba(74,74,74,1);
		margin-top: 8px;
		line-height:23px;
	}
	.text2>p:nth-child(1){
		font-size:15px;
		font-weight:400;
		color:rgba(74,74,74,1);
		line-height:23px;
	}
	.text2>p:nth-child(2){
		margin-top: 8px;
		font-size:30px;
		font-weight:600;
		color:rgba(29,181,255,1);
		line-height:23px;
	}
	.chartsDoc{
		width:1035px;
		height:344px;
		padding: 10px 20px;
		background:rgba(255,255,255,1);
		border-radius:3px;
		
	}
	.chartsDocheader{
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.chartsDocheader>div:nth-child(1){
		width: 400px;
	}
	.chartsDocheader>div:nth-child(1)>div{
		width: 400px;
	}
	.datebtn>div:hover{
		border:1px solid yellow;
		
	}
	.datebtn{
		display: flex;
	}
	.datebtn>div{
		margin-right: 13px;
		cursor: pointer;
		width:93px;
		height:42px;
		background:rgba(234,234,234,1);
		border-radius:24px;
		border:1px solid rgba(221,227,232,1);
		font-size:19px;
		font-family:PingFangSC-Medium,PingFang SC;
		font-weight:500;
		color:rgba(155,155,155,1);
		line-height:24px;
		display: flex;justify-content: center;
		align-items: center;
	}
	.datebtn>div.active{
		font-size:19px;
		font-family:PingFangSC-Medium,PingFang SC;
		font-weight:500;
		color:rgba(255,255,255,1);
		line-height:24px;
		background:rgba(29,181,255,1);
	}
	.chartsDoccontent{
		display: flex;
		justify-content: space-between;
	}
	.chartsDoccontent>div{
		width:497px;
		height: 290px;
		margin-top: 10px;
		/*background: #CCCCCC;*/
	}
	
</style>


// WEBPACK FOOTER //
// src/component/userEcharts.vue